import { AlertTriangle } from 'lucide-react';

/** The text an operator sees when a region query failed (KB #854). */
export const REGIONS_DEGRADED_MESSAGE = 'Query failed, this is not zero sessions';

interface QueryDegradedNoticeProps {
  message?: string;
  detail?: string;
}

/**
 * Amber notice for a response the API marked `degraded`: the query behind it
 * failed, so an empty panel would be a lie. Shown in place of the empty state,
 * never beside it.
 */
export function QueryDegradedNotice({
  message = REGIONS_DEGRADED_MESSAGE,
  detail = 'The API could not read active sessions by region. Check the API error logs; the panel refreshes every 30 seconds.',
}: QueryDegradedNoticeProps): JSX.Element {
  return (
    <div
      className="flex items-start gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 dark:border-amber-900/40 dark:bg-amber-950/30"
      role="alert"
    >
      <AlertTriangle
        className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400"
        aria-hidden
      />
      <div className="text-sm">
        <p className="font-medium text-amber-900 dark:text-amber-200">{message}</p>
        <p className="mt-0.5 text-xs text-amber-900/80 dark:text-amber-200/80">{detail}</p>
      </div>
    </div>
  );
}
